import { noop } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { hitSlop } from 'design-system';
import Text from 'design-system/Text';
import { useActionSheet } from 'hooks/useActionSheet';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const strings = {
    title: 'How can we help you?',
    options: {
        helpCenter: 'Visit the help center',
        chat: 'Chat to a human',
        pendingTopups: 'My deposit is still pending',
        cancel: 'Cancel',
    },
};
const ContactSupportTextButton = ({ showPendingDepositHelp }) => {
    const { showActionSheetWithOptions } = useActionSheet();
    const navigation = useMainStackNavigation();
    const sheetOptions = useMemo(() => {
        const options = [
            {
                title: strings.options.helpCenter,
                action: Links.openEmmaHelp,
            },
            {
                title: strings.options.chat,
                action: () => navigation.navigateDeprecated('Support', {}),
            },
            { title: strings.options.cancel, action: noop },
        ];
        if (showPendingDepositHelp) {
            options.unshift({
                title: strings.options.pendingTopups,
                action: Links.openPendingDepositHelp,
            });
        }
        return options;
    }, [showPendingDepositHelp]);
    const handlePress = useCallback(() => {
        showActionSheetWithOptions({
            options: sheetOptions.map((o) => o.title),
            title: strings.title,
            cancelButtonIndex: sheetOptions.length - 1,
        }, (i) => {
            if (i !== undefined) {
                sheetOptions[i].action();
            }
        });
    }, [sheetOptions, showActionSheetWithOptions]);
    return (<View style={styles.container}>
      <TouchableOpacity onPress={handlePress} hitSlop={hitSlop}>
        <Text Text-14>
          Having issues?{' '}
          <Text Text-14 Primary>
            Contact support
          </Text>
        </Text>
      </TouchableOpacity>
    </View>);
};
export default ContactSupportTextButton;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
});
